import get from 'lodash/get';
import difference from 'lodash/difference';
import OptimizelyService from 'admin/services/api/OptimizelyService';

class OptimizelyStore {
  defaultState = {};

  getExperiments(bypassCache) {
    if (!get(window, 'optimizely.get')) return Promise.resolve([]);

    const optimizelyData = window.optimizely.get('state').getVariationMap();
    let updateDatastore = false;

    this.push('activate');

    return Promise.resolve().then(() => {
      if (this.state && !bypassCache) {
        updateDatastore = !!difference(Object.keys(optimizelyData), Object.keys(this.state)).length;

        this.setState(Object.assign(optimizelyData, this.state), updateDatastore);

        return this.state;
      }

      if (this.pendingRequest) {
        return this.pendingRequest;
      }

      this.pendingRequest = OptimizelyService.getVariationState()
        .then(response => JSON.parse(get(response, 'data.message', '{}')))
        .then((experiments) => {
          updateDatastore = !!difference(Object.keys(optimizelyData), Object.keys(experiments)).length;
          return experiments;
        })
        .then(response => this.getCombinedState(optimizelyData, response))
        .then((combinedState) => {
          this.setState(combinedState, updateDatastore);
          return combinedState;
        });

      this.registerCampaignListener();

      return this.pendingRequest;
    });
  }

  getCombinedState(optimizelyData, experiments) {
    const state = Object.assign(optimizelyData, experiments);

    // manual triggering of credits test experiment
    const CREDITS_TEST_EXPERIMENT_ID = '14482550530';
    if (state[CREDITS_TEST_EXPERIMENT_ID]) {
      this.push(
        'user',
        { attributes: { noTrialToken: true } }
      );
    }

    Object.keys(state).forEach((experimentId) => {
      this.activateExperiment(experimentId, state[experimentId].index, state[experimentId].pageName);
    });

    this.push('activate');

    return state;
  }

  setState(state, updateDatastore = false) {
    const newState = state || this.defaultState;
    this.state = newState;
    if (updateDatastore) OptimizelyService.setVariationState(this.state);
    return this.state;
  }

  push(type, data = {}) {
    const optimizely = (window.optimizely || []);
    window.setTimeout(() => optimizely.push({ type, ...data }));
  }

  trackPage(pageName) {
    this.push('page', { pageName });
  }

  bucketVisitor(experimentId, variationIndex) {
    this.push('bucketVisitor', { experimentId, variationIndex });
  }

  trackEvent(eventName) {
    this.push('event', { eventName });
  }

  activateExperiment(experimentId, variationIndex, pageName) {
    this.bucketVisitor(experimentId, variationIndex);
    this.trackPage(pageName);
  }

  setUpExperiment({
    experimentId,
    condition,
    variations = { true: 1, false: 0 },
    pageName
  } = {}) {
    return this.getExperiments().then((experiments) => {
      let variationIndex = 0;
      let updateDatastore = true;

      if (experiments[experimentId]) {
        variationIndex = experiments[experimentId].index;
        updateDatastore = false;
      } else {
        variationIndex = condition ? variations.true : variations.false;
        experiments[experimentId] = { index: variationIndex };
      }

      experiments[experimentId].pageName = pageName;
      this.setState(experiments, updateDatastore);

      this.activateExperiment(experimentId, variationIndex, pageName);
      this.push('activate');

      return experiments;
    });
  }

  campaignDecidedHandler() {
    if (!get(window, 'optimizely.get')) return;

    const optimizelyData = window.optimizely.get('state').getVariationMap();
    const updateDatastore = !!difference(Object.keys(optimizelyData), Object.keys(this.state)).length;
    this.setState(Object.assign(optimizelyData, this.state), updateDatastore);
  }

  registerCampaignListener() {
    this.push('addListener', {
      filter: {
        type: 'lifecycle',
        name: 'campaignDecided'
      },
      handler: this.campaignDecidedHandler.bind(this)
    });
  }
}

export default new OptimizelyStore();



// WEBPACK FOOTER //
// ./src/app/admin/stores/OptimizelyStore/index.js